export default "__VITE_ASSET__61274a12__"